import { Info } from "lucide-react";

/**
 * WhyWeAsk — small inline tip underneath sensitive fields explaining the
 * reason we collect the data. Quiet, charcoal text on a tinted line.
 */
export const WhyWeAsk = ({ children }) => (
  <p className="mt-2 flex items-start gap-1.5 text-[12.5px] text-[#475569] leading-relaxed">
    <Info
      size={12}
      className="mt-0.5 text-[var(--teal)] flex-shrink-0"
      strokeWidth={2}
    />
    <span>{children}</span>
  </p>
);

export default WhyWeAsk;
